import useNotify from 'hooks/useNotify';
import { ImpactGoal } from 'types';
import useLazyResource from 'util/resource/useLazyResource';
import CompanyAPI from '..';

export default function useUpdateImpactGoals(
  companyId: number,
  { onSuccess, onFailure }: { onSuccess?: (goals: ImpactGoal[]) => void; onFailure?: () => void },
) {
  const notify = useNotify();
  return useLazyResource((impactGoalIds: string[]) => CompanyAPI.impactGoals.save(companyId, impactGoalIds), {
    onSuccess: goals => {
      onSuccess?.(goals);
    },
    onFailure: () => {
      notify('error', 'Failed to update impact goals');
      onFailure?.();
    },
  });
}
